import {Injectable} from '@angular/core';
import {CanDeactivate, Router} from '@angular/router';
import {Observable} from 'rxjs';
import {StorageHandler} from '../handlers/storage-handler';

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}


@Injectable()
export class DirtyCheckGuard implements CanDeactivate<ComponentCanDeactivate> {
  public scenario: any;

  constructor(private router: Router, private storageHandler: StorageHandler) {
  }

  canDeactivate(target: ComponentCanDeactivate): boolean | Observable<boolean> {
    // if there are no pending changes, just allow deactivation; else confirm first
    /* return target.canDeactivate()?
       true :
       confirm('WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.');

   }*/
    if (target.canDeactivate()) {
      console.log('deactivate');
      return true;
    } else {
      if (confirm('WARNING: You have unsaved changes. Press Cancel to go back and save these changes, or OK to lose these changes.')) {
        console.log('ok');
        this.scenario = JSON.parse(this.storageHandler.getLocalStorage('scenario'));
        this.scenario.selectedStep = this.scenario.nextSelectedStep;
        this.scenario.hasChanges = false;
        this.storageHandler.setLocalStorage('scenario', JSON.stringify(this.scenario));

        return true;
      } else {
        this.scenario = JSON.parse(this.storageHandler.getLocalStorage('scenario'));
        this.scenario.selectedStep = this.scenario.lastSelectedStep;
        this.storageHandler.setLocalStorage('scenario', JSON.stringify(this.scenario));
        return false;
      }
    }
  }
}



